var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-462.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(421.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58789063,14.6770909 L9.58789063,12.4 L14,12.4 C14.7731986,12.4 15.4,11.7731986 15.4,11 L15.4,3 C15.4,2.22680135 14.7731986,1.6 14,1.6 L2,1.6 C1.22680135,1.6 0.6,2.22680135 0.6,3 L0.6,11 C0.6,11.7731986 1.22680135,12.4 2,12.4 L6.18210215,12.4 L9.58789063,14.6770909 Z",
    stroke: "#1DBADF",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DBADF",
    fillRule: "evenodd",
    cx: 12,
    cy: 7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DBADF",
    fillRule: "evenodd",
    cx: 4,
    cy: 7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DBADF",
    fillRule: "evenodd",
    cx: 8,
    cy: 7,
    r: 1.2
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.480cde58.svg";
export { ForwardRef as ReactComponent };